import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import Navbar from 'components/Header/Navbar';
import Footer from 'components/Footer';
import SbPageHeader from 'components/layout/SbPageHeader';
import SupportTicketForm from 'components/support/SupportTicketForm';
import SupportTicketList from 'components/support/SupportTicketList';

const SupportPage: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [listKey, setListKey] = useState(0);
  const [formError, setFormError] = useState<string | null>(null);

  const handleFormSuccess = useCallback(() => {
    setListKey((k) => k + 1);
    setFormError(null);
  }, []);

  const handleFormError = useCallback((message: string) => {
    setFormError(message);
  }, []);

  if (!user) {
    navigate('/giris', { replace: true });
    return null;
  }

  return (
    <div className="min-vh-100 d-flex flex-column" style={{ backgroundColor: 'var(--sb-bg-muted)' }}>
      <Navbar />
      <main className="sb-page-container py-4 sb-page-shell flex-grow-1">
        <SbPageHeader
          title="Teknik Destek"
          subtitle="Sorularınız ve sorunlarınız için destek talebi oluşturun."
          backTo={{ to: '/', label: 'Ana Sayfaya Dön' }}
        />
        {formError && (
          <div className="alert alert-warning mb-3" role="alert">
            {formError}
          </div>
        )}
        <div className="sb-support-grid">
          <SupportTicketForm onSuccess={handleFormSuccess} onError={handleFormError} />
          <SupportTicketList key={listKey} />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default SupportPage;
